<template>
  <div>
    <p id="ppp">页面跳转中...</p>
  </div>
</template>
<script>
export default {
  created() {
    var obj = {
      token: this.getUrlKey("token"),
      identityId: this.getUrlKey("identityId"),
      share: this.getUrlKey("share"),
    };
    localStorage.setItem("Authorization", JSON.stringify(obj));
    this.$router.push({
      path: this.getUrlKey("redirectUri"),
    });
  },
  methods: {
    //http://61.143.40.50:59409/gps-api/v1/auth/sso?password=123456&loginName=zhcw
    getUrlKey(name) {
      return (
        decodeURIComponent(
          (new RegExp("[?|&]" + name + "=" + "([^&;]+?)(&|#|;|$)").exec(
            location.href
          ) || [, ""])[1].replace(/\+/g, "%20")
        ) || null
      );
    },
  },
};
</script>
<style lang="">
#ppp {
  width: 100%;
  text-align: center;
  margin-top: 100px;
  font-size: 24px;
}
</style>


// WEBPACK FOOTER //
// src/components/login/auth.vue